import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MtnaTrackByPropertyPipeModule } from '@mtna/core-angular';

import { RdsRemoveChipLabelPipeModule } from '../core/pipes';
import { RdsChipsComponent } from './chips.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatChipsModule,
    MatIconModule,
    MtnaTrackByPropertyPipeModule,
    DragDropModule,
    RdsRemoveChipLabelPipeModule,
  ],
  exports: [RdsChipsComponent],
  declarations: [RdsChipsComponent],
  providers: [],
})
export class RdsChipsModule {}

export * from './chips.component';
